export type TokenUsage = (typeof TokenUsage)[keyof typeof TokenUsage];

export const TokenUsage = {
    ReUse: 'ReUse',
    OneTimeOnly: 'OneTimeOnly',
} as const;
